/** Согласовано с бэкендом (формула PaymentIntent в StripeService). */
import {store} from "../../redux/Store";

const parseEnvNumber = (raw: string | undefined, fallback: number): number => {
    if (!raw) return fallback;
    const parsed = Number(raw);
    return Number.isFinite(parsed) ? parsed : fallback;
};

export function getStripePercentFee(): number {
    const p = store.getState().PaymentConfigReducer;
    if (p?.loaded) return p.stripePercentFee;
    return parseEnvNumber(process.env.REACT_APP_STRIPE_PERCENT_FEE, 0.029);
}

export function getStripeFixedFee(): number {
    const p = store.getState().PaymentConfigReducer;
    if (p?.loaded) return p.stripeFixedFeeUsd;
    return parseEnvNumber(process.env.REACT_APP_STRIPE_FIXED_FEE, 0.3);
}

export function getStripeCommissionLabel(): string {
    const pf = getStripePercentFee();
    const fx = getStripeFixedFee();
    return `${(pf * 100).toFixed(1)}% + $${fx.toFixed(2)}`;
}

/** Сумма к списанию с карты: (сумма заказа + фикс) / (1 − %). */
export const calculateTotalChargedWithStripeFee = (orderTotal: number): number => {
    const STRIPE_PERCENT_FEE = getStripePercentFee();
    const STRIPE_FIXED_FEE = getStripeFixedFee();
    const total = (orderTotal + STRIPE_FIXED_FEE) / (1 - STRIPE_PERCENT_FEE);
    return Number(total.toFixed(2));
};

/** Доля процентной комиссии Stripe от итога к списанию — для поля {@code fee} заказа. */
export const calculateStripePercentFeeAmount = (orderTotal: number): number => {
    const chargedTotal = calculateTotalChargedWithStripeFee(orderTotal);
    return Number((chargedTotal * getStripePercentFee()).toFixed(2));
};
